import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";



Sentry.init({
  dsn: "https://a3185b408b36a121b76b3d052fcb1807@o10127.ingest.us.sentry.io/4509922155757568",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
